var _path, _g, _path2, _path3, _circle, _path4, _g2, _circle2, _rect, _rect2, _rect3, _path5, _circle3, _path6, _g3, _circle4, _rect4, _rect5, _rect6, _rect7, _rect8, _path7, _circle5, _path8, _g4, _circle6, _rect9, _rect0, _rect1, _g5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZeroStateItemRu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 911 695",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_31_2309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 473,
    height: 198
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H473L413 198H0V0Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_31_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398 65.5C398 29.6015 427.101 0 463 0V0C498.899 0 528 29.6015 528 65.5V65.5C528 101.399 498.899 131 463 131V131C427.101 131 398 101.399 398 65.5V65.5Z",
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.25 85.625C445.25 79.2737 452.973 74.125 462.5 74.125C472.027 74.125 479.75 79.2737 479.75 85.625",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.5 65.5C468.851 65.5 474 60.3513 474 54C474 47.6487 468.851 42.5 462.5 42.5C456.149 42.5 451 47.6487 451 54C451 60.3513 456.149 65.5 462.5 65.5Z",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 147,
    width: 35.0382,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 432.718,
    y: 147,
    width: 106.282,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205 65.5C205 29.6015 234.101 0 270 0V0C305.899 0 335 29.6015 335 65.5V65.5C335 101.399 305.899 131 270 131V131C234.101 131 205 101.399 205 65.5V65.5Z",
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.25 85.625C252.25 79.2737 259.973 74.125 269.5 74.125C279.027 74.125 286.75 79.2737 286.75 85.625",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.5 65.5C275.851 65.5 281 60.3513 281 54C281 47.6487 275.851 42.5 269.5 42.5C263.149 42.5 258 47.6487 258 54C258 60.3513 263.149 65.5 269.5 65.5Z",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193,
    y: 147,
    width: 153,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 65.5C12 29.6015 41.1015 0 77 0V0C112.899 0 142 29.6015 142 65.5V65.5C142 101.399 112.899 131 77 131V131C41.1015 131 12 101.399 12 65.5V65.5Z",
    fill: "#2F2F30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.25 85.625C59.25 79.2737 66.9731 74.125 76.5 74.125C86.0269 74.125 93.75 79.2737 93.75 85.625",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5 65.5C82.8513 65.5 88 60.3513 88 54C88 47.6487 82.8513 42.5 76.5 42.5C70.1487 42.5 65 47.6487 65 54C65 60.3513 70.1487 65.5 76.5 65.5Z",
    stroke: "#8B8B8B",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 147,
    width: 35.0382,
    height: 20,
    rx: 10,
    fill: "#959598"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.7178,
    y: 147,
    width: 106.282,
    height: 20,
    rx: 10,
    fill: "#959598"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_31_2309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 439,
    y: 0,
    width: 472,
    height: 198
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M499 0H911V198H439L499 0Z",
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_31_2309)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M384 0H514V131H384V0Z",
    fill: "#2F2F30"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 448.5,
    cy: 65.5,
    r: 26,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_31_2309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 427,
    y: 43,
    width: 22,
    height: 23
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M433.5 48.5L427.5 56.5L448.5 65.5L447.5 43L433.5 48.5Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_31_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M448.5 81C457.613 81 464 74.6127 464 65.5C464 56.3873 457.613 50 448.5 50C439.387 50 433 56.3873 433 65.5C433 74.6127 439.387 81 448.5 81ZM448.5 85C459.27 85 468 76.2696 468 65.5C468 54.7304 459.27 46 448.5 46C437.73 46 429 54.7304 429 65.5C429 76.2696 437.73 85 448.5 85Z",
    fill: "#8B8B8B"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 449,
    cy: 66,
    r: 3.5,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 398.862,
    y: 147,
    width: 68.3244,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 476.53,
    y: 147,
    width: 48.4695,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 446.152,
    y: 178,
    width: 63.8473,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M577 0H707V131H577V0Z",
    fill: "#2F2F30"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 641.5,
    cy: 65.5,
    r: 26,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_31_2309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 620,
    y: 43,
    width: 22,
    height: 23
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M626.5 48.5L620.5 56.5L641.5 65.5L640.5 43L626.5 48.5Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_31_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M641.5 81C650.613 81 657 74.6127 657 65.5C657 56.3873 650.613 50 641.5 50C632.387 50 626 56.3873 626 65.5C626 74.6127 632.387 81 641.5 81ZM641.5 85C652.27 85 661 76.2696 661 65.5C661 54.7304 652.27 46 641.5 46C630.73 46 622 54.7304 622 65.5C622 76.2696 630.73 85 641.5 85Z",
    fill: "#8B8B8B"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 642,
    cy: 66,
    r: 3.5,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 565,
    y: 147,
    width: 35.0382,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 611.718,
    y: 147,
    width: 106.282,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 580,
    y: 178,
    width: 14.5534,
    height: 20,
    rx: 7.27672,
    fill: "#4A4A4A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 601.596,
    y: 178,
    width: 54.9275,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 664.034,
    y: 178,
    width: 38.9657,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M770 0H900V131H770V0Z",
    fill: "#2F2F30"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 834.5,
    cy: 65.5,
    r: 26,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_31_2309",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 813,
    y: 43,
    width: 22,
    height: 23
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M819.5 48.5L813.5 56.5L834.5 65.5L833.5 43L819.5 48.5Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_31_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M834.5 81C843.613 81 850 74.6127 850 65.5C850 56.3873 843.613 50 834.5 50C825.387 50 819 56.3873 819 65.5C819 74.6127 825.387 81 834.5 81ZM834.5 85C845.27 85 854 76.2696 854 65.5C854 54.7304 845.27 46 834.5 46C823.73 46 815 54.7304 815 65.5C815 76.2696 823.73 85 834.5 85Z",
    fill: "#8B8B8B"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 835,
    cy: 66,
    r: 3.5,
    stroke: "#8B8B8B",
    strokeWidth: 5
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 758,
    y: 147,
    width: 153,
    height: 20,
    rx: 10,
    fill: "#959598"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 832.152,
    y: 178,
    width: 63.8473,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 773,
    y: 178,
    width: 51.6412,
    height: 20,
    rx: 10,
    fill: "#4A4A4A"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddddd_31_2309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M605.5 239V511C605.5 512.933 603.933 514.5 602 514.5H309C307.067 514.5 305.5 512.933 305.5 511V239C305.5 237.067 307.067 235.5 309 235.5H438.958C439.903 235.5 440.824 235.202 441.59 234.65L453.452 226.093C454.675 225.212 456.325 225.212 457.548 226.093L469.41 234.65C470.176 235.202 471.097 235.5 472.042 235.5H602C603.933 235.5 605.5 237.067 605.5 239Z",
    fill: "#23262D",
    stroke: "#4E4E4E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 270,
    width: 21.1794,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.428,
    y: 270,
    width: 79.9351,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 451.294,
    y: 270,
    width: 56.7061,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_2309)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 399,
    width: 46.2595,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.68,
    y: 399,
    width: 140.321,
    height: 20,
    rx: 10,
    fill: "#404648"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 444.42,
    y: 457,
    width: 124.58,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329,
    y: 457,
    width: 100.763,
    height: 20,
    rx: 10,
    fill: "#404648"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 313,
    width: 301,
    height: 60,
    fill: "#C4C4C4",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.735 359.263V350.772H331.195C331.685 350.381 332.143 349.831 332.569 349.121C332.995 348.411 333.357 347.437 333.656 346.202C333.954 344.966 334.16 343.368 334.273 341.408L334.849 332.182H348.794V350.772H351.223V359.241H347.43V354H333.528V359.263H329.735ZM335.797 350.772H345.001V335.495H338.407L338.066 341.408C337.974 342.892 337.825 344.22 337.619 345.392C337.413 346.564 337.153 347.597 336.841 348.492C336.528 349.38 336.18 350.14 335.797 350.772ZM361.41 354.32C359.812 354.32 358.427 353.968 357.256 353.265C356.084 352.562 355.175 351.578 354.528 350.314C353.889 349.05 353.569 347.572 353.569 345.882C353.569 344.192 353.889 342.711 354.528 341.44C355.175 340.168 356.084 339.181 357.256 338.478C358.427 337.775 359.812 337.423 361.41 337.423C363.008 337.423 364.393 337.775 365.565 338.478C366.737 339.181 367.643 340.168 368.282 341.44C368.928 342.711 369.251 344.192 369.251 345.882C369.251 347.572 368.928 349.05 368.282 350.314C367.643 351.578 366.737 352.562 365.565 353.265C364.393 353.968 363.008 354.32 361.41 354.32ZM361.432 351.23C362.298 351.23 363.023 350.992 363.605 350.516C364.187 350.033 364.621 349.387 364.905 348.577C365.196 347.768 365.341 346.866 365.341 345.871C365.341 344.87 365.196 343.964 364.905 343.155C364.621 342.338 364.187 341.688 363.605 341.205C363.023 340.722 362.298 340.481 361.432 340.481C360.544 340.481 359.805 340.722 359.216 341.205C358.633 341.688 358.197 342.338 357.905 343.155C357.621 343.964 357.479 344.87 357.479 345.871C357.479 346.866 357.621 347.768 357.905 348.577C358.197 349.387 358.633 350.033 359.216 350.516C359.805 350.992 360.544 351.23 361.432 351.23ZM385.639 331.585L386.981 334.078C386.505 334.49 385.973 334.788 385.383 334.973C384.794 335.158 384.101 335.278 383.306 335.335C382.517 335.385 381.58 335.42 380.493 335.442C379.272 335.47 378.274 335.701 377.5 336.134C376.725 336.567 376.132 337.224 375.721 338.105C375.309 338.979 375.039 340.094 374.911 341.45H375.092C375.603 340.449 376.321 339.685 377.244 339.16C378.167 338.634 379.25 338.371 380.493 338.371C381.85 338.371 383.047 338.677 384.083 339.288C385.127 339.891 385.941 340.768 386.523 341.919C387.113 343.07 387.407 344.462 387.407 346.095C387.407 347.778 387.091 349.238 386.459 350.474C385.827 351.702 384.929 352.651 383.764 353.318C382.606 353.986 381.232 354.32 379.641 354.32C378.057 354.32 376.679 353.975 375.507 353.286C374.343 352.59 373.441 351.564 372.801 350.207C372.169 348.844 371.853 347.164 371.853 345.168V343.698C371.853 339.849 372.571 336.976 374.005 335.08C375.44 333.183 377.567 332.217 380.387 332.182C381.225 332.168 381.974 332.164 382.635 332.171C383.302 332.178 383.885 332.146 384.382 332.075C384.879 332.004 385.298 331.841 385.639 331.585ZM379.662 351.23C380.451 351.23 381.132 351.028 381.708 350.623C382.283 350.211 382.723 349.629 383.029 348.876C383.341 348.123 383.498 347.232 383.498 346.202C383.498 345.186 383.341 344.323 383.029 343.613C382.716 342.896 382.272 342.349 381.697 341.972C381.122 341.596 380.436 341.408 379.641 341.408C379.044 341.408 378.508 341.514 378.032 341.727C377.556 341.94 377.152 342.253 376.818 342.665C376.484 343.077 376.228 343.577 376.051 344.167C375.873 344.756 375.777 345.435 375.763 346.202C375.763 347.743 376.111 348.968 376.807 349.877C377.503 350.779 378.455 351.23 379.662 351.23ZM395.397 354.33C394.36 354.33 393.426 354.146 392.596 353.776C391.772 353.4 391.118 352.846 390.635 352.114C390.159 351.383 389.922 350.481 389.922 349.408C389.922 348.485 390.092 347.722 390.433 347.118C390.774 346.514 391.239 346.031 391.828 345.669C392.418 345.307 393.082 345.033 393.821 344.849C394.566 344.657 395.337 344.518 396.132 344.433C397.091 344.334 397.869 344.245 398.466 344.167C399.062 344.082 399.495 343.954 399.765 343.783C400.042 343.606 400.181 343.332 400.181 342.963V342.899C400.181 342.097 399.943 341.475 399.467 341.035C398.991 340.594 398.306 340.374 397.411 340.374C396.466 340.374 395.717 340.58 395.163 340.992C394.616 341.404 394.247 341.891 394.055 342.452L390.454 341.94C390.738 340.946 391.207 340.115 391.86 339.447C392.514 338.773 393.313 338.268 394.257 337.935C395.202 337.594 396.246 337.423 397.39 337.423C398.178 337.423 398.963 337.516 399.744 337.7C400.525 337.885 401.239 338.19 401.885 338.616C402.532 339.036 403.05 339.607 403.441 340.332C403.838 341.056 404.037 341.962 404.037 343.048V354H400.33V351.752H400.202C399.968 352.207 399.637 352.633 399.211 353.031C398.792 353.421 398.263 353.737 397.624 353.979C396.992 354.213 396.25 354.33 395.397 354.33ZM396.399 351.496C397.173 351.496 397.844 351.344 398.412 351.038C398.98 350.726 399.417 350.314 399.723 349.803C400.035 349.291 400.191 348.734 400.191 348.13V346.202C400.071 346.301 399.865 346.393 399.574 346.479C399.289 346.564 398.97 346.638 398.615 346.702C398.26 346.766 397.908 346.823 397.56 346.873C397.212 346.923 396.91 346.965 396.654 347.001C396.079 347.079 395.564 347.207 395.11 347.384C394.655 347.562 394.297 347.81 394.034 348.13C393.771 348.442 393.64 348.847 393.64 349.344C393.64 350.055 393.899 350.591 394.417 350.953C394.936 351.315 395.596 351.496 396.399 351.496ZM407.915 354V337.636H414.787C416.725 337.636 418.256 338.023 419.378 338.798C420.507 339.572 421.072 340.651 421.072 342.036C421.072 342.952 420.752 343.702 420.113 344.284C419.481 344.859 418.618 345.246 417.525 345.445C418.384 345.516 419.137 345.733 419.783 346.095C420.436 346.457 420.948 346.933 421.317 347.523C421.686 348.112 421.871 348.79 421.871 349.558C421.871 350.46 421.633 351.244 421.157 351.912C420.689 352.572 420.003 353.087 419.101 353.457C418.206 353.819 417.12 354 415.841 354H407.915ZM411.527 350.964H415.841C416.551 350.964 417.109 350.797 417.514 350.463C417.919 350.122 418.121 349.661 418.121 349.078C418.121 348.403 417.919 347.874 417.514 347.491C417.109 347.1 416.551 346.905 415.841 346.905H411.527V350.964ZM411.527 344.412H414.861C415.387 344.412 415.838 344.337 416.214 344.188C416.591 344.032 416.878 343.815 417.077 343.538C417.276 343.254 417.375 342.917 417.375 342.526C417.375 341.965 417.145 341.525 416.683 341.205C416.228 340.886 415.596 340.726 414.787 340.726H411.527V344.412ZM428.772 348.78L435.324 337.636H439.287V354H435.558V342.846L429.028 354H425.054V337.636H428.772V348.78ZM441.415 340.8V337.636H455.733V340.8H450.438V354H446.71V340.8H441.415ZM461.414 342.963H466.24C468.328 342.963 469.944 343.471 471.087 344.487C472.231 345.502 472.806 346.834 472.813 348.482C472.806 349.554 472.543 350.506 472.025 351.337C471.513 352.168 470.768 352.821 469.787 353.297C468.814 353.766 467.632 354 466.24 354H458.804V337.636H462.522V350.836H466.24C467.078 350.836 467.767 350.623 468.307 350.197C468.846 349.763 469.116 349.21 469.116 348.535C469.116 347.825 468.846 347.246 468.307 346.798C467.767 346.351 467.078 346.127 466.24 346.127H461.414V342.963ZM483.56 354V337.636H490.431C492.37 337.636 493.901 338.023 495.023 338.798C496.152 339.572 496.717 340.651 496.717 342.036C496.717 342.952 496.397 343.702 495.758 344.284C495.126 344.859 494.263 345.246 493.169 345.445C494.028 345.516 494.781 345.733 495.428 346.095C496.081 346.457 496.592 346.933 496.962 347.523C497.331 348.112 497.516 348.79 497.516 349.558C497.516 350.46 497.278 351.244 496.802 351.912C496.333 352.572 495.648 353.087 494.746 353.457C493.851 353.819 492.764 354 491.486 354H483.56ZM487.171 350.964H491.486C492.196 350.964 492.754 350.797 493.158 350.463C493.563 350.122 493.766 349.661 493.766 349.078C493.766 348.403 493.563 347.874 493.158 347.491C492.754 347.1 492.196 346.905 491.486 346.905H487.171V350.964ZM487.171 344.412H490.506C491.031 344.412 491.482 344.337 491.859 344.188C492.235 344.032 492.523 343.815 492.722 343.538C492.92 343.254 493.02 342.917 493.02 342.526C493.02 341.965 492.789 341.525 492.327 341.205C491.873 340.886 491.241 340.726 490.431 340.726H487.171V344.412ZM517.557 349.515L522.415 337.636H525.526L518.91 354H516.215L509.748 337.636H512.827L517.557 349.515ZM511.858 337.636V354H508.14V337.636H511.858ZM523.417 354V337.636H527.103V354H523.417ZM534.709 348.78L541.261 337.636H545.224V354H541.496V342.846L534.965 354H530.991V337.636H534.709V348.78ZM549.185 354V337.636H553.041V344.241H554.447L559.369 337.636H564.014L557.952 345.669L564.078 354H559.412L554.927 347.832H553.041V354H549.185ZM572.729 354.32C571.095 354.32 569.692 353.961 568.521 353.244C567.356 352.526 566.457 351.536 565.825 350.271C565.2 349 564.888 347.537 564.888 345.882C564.888 344.22 565.207 342.754 565.847 341.482C566.486 340.204 567.388 339.21 568.553 338.499C569.724 337.782 571.109 337.423 572.707 337.423C574.036 337.423 575.211 337.668 576.234 338.158C577.263 338.641 578.084 339.327 578.695 340.214C579.305 341.095 579.653 342.125 579.739 343.304H576.053C575.903 342.516 575.548 341.859 574.987 341.333C574.433 340.8 573.691 340.534 572.761 340.534C571.972 340.534 571.28 340.747 570.683 341.173C570.087 341.592 569.621 342.196 569.288 342.984C568.961 343.773 568.798 344.717 568.798 345.818C568.798 346.933 568.961 347.892 569.288 348.695C569.614 349.49 570.072 350.104 570.662 350.538C571.259 350.964 571.958 351.177 572.761 351.177C573.329 351.177 573.837 351.07 574.284 350.857C574.739 350.637 575.119 350.321 575.424 349.909C575.729 349.497 575.939 348.996 576.053 348.407H579.739C579.646 349.565 579.305 350.591 578.716 351.486C578.126 352.374 577.324 353.07 576.308 353.574C575.293 354.071 574.099 354.32 572.729 354.32Z",
    fill: "#35FFD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddddd_31_2309",
    x: 225,
    y: 224,
    width: 461,
    height: 471,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.76726
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.1069
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0196802 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_2309"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.6501
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.66004
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0282725 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_31_2309",
    result: "effect2_dropShadow_31_2309"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12.5216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.00862
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.035 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_31_2309",
    result: "effect3_dropShadow_31_2309"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.3363
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.93452
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0417275 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_31_2309",
    result: "effect4_dropShadow_31_2309"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 41.7776
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.711
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0503198 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_31_2309",
    result: "effect5_dropShadow_31_2309"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 100
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_31_2309",
    result: "effect6_dropShadow_31_2309"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_31_2309",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_2309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202,
    height: 20,
    fill: "white",
    transform: "translate(329 399)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroStateItemRu);
export default __webpack_public_path__ + "static/media/zeroState-item-ru.19840b40.svg";
export { ForwardRef as ReactComponent };